import React from 'react';
import {
	PlainButton,
	PaddingWrapper,
	DrawerHeader,
} from 'components/styled-components';
import { Drawer } from '@blueprintjs/core';
import FormTextGroup from 'components/forms/components/form-text-group';
import FormTextAreaGroup from 'components/forms/components/form-text-area-group';
import FormSelectGroup from 'components/forms/components/form-select-group';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import constants from 'utils/constants';

const { REVIEW_STATUSES } = constants;

const ReviewSchema = Yup.object().shape({
	Response: Yup.string()
		.min(1, 'Too Short!')
		.max(200, 'Too Long!')
		.required('Required')
		.nullable(),
	Comment: Yup.string()
		.min(1, 'Too Short!')
		.max(200, 'Too Long!')
		.nullable(),
	// thirdParties: Yup.array().of(Yup.object())
	// 	.min(1, 'Third Party Required')
	// 	.required('Required')
});

const initialValues = { ReviewID: null, Response: null, Comment: null, DepartmentID: null };

const ReviewOptions = [
	{
		Response: 0,
		ResponseLabel: "Denied"
	},
	{
		Response: 1,
		ResponseLabel: "Approved"
	}
];

const DepartmentalReviewDrawer = ({ isOpen, closeDrawer, handleSave, departments, review }) => {
	const DepartmentName = departments.filter(dp => dp.departmentID == review.DepartmentID).length > 0 ? departments.filter(dp => dp.departmentID == review.DepartmentID)[0].departmentName : "Unknown Department";
	return (
		<Drawer isOpen={isOpen} onClose={closeDrawer}>
			<Formik
				initialValues={review}
				validationSchema={ReviewSchema}
				onSubmit={(values, actions) => {
					handleSave(values);
				}}
			>
				{({ isSubmitting, values, handleChange }) => (
					<Form>
						<DrawerHeader>
							<span>Departmental Review: {DepartmentName}</span>
							<div>
								<PlainButton type="submit" disabled={isSubmitting}>
									Submit
								</PlainButton>
							</div>
						</DrawerHeader>
						<PaddingWrapper padding="2rem">
							<FormSelectGroup
								label="Response"
								requiredLabel={true}
								name="Response"
								asyncOptions={REVIEW_STATUSES.filter(rs => rs.value !== null)}
								labelKey="label"
								valueKey="value"
								value={REVIEW_STATUSES.find(rs => rs.value == values.Response && rs.value !== null)}
								onChange={(key, value) => {
									handleChange({ target: { name: key, value: value === null ? null : value.value }});
								}}
							/>
							<FormTextAreaGroup
								label="Comment"
								requiredLabel={false}
								name="Comment"
								value={values.Comment === null ? '' : values.Comment}
								handleChange={handleChange}
							/>
						</PaddingWrapper>
					</Form>
				)}
			</Formik>
		</Drawer>
	);
};

export default DepartmentalReviewDrawer;
